import styled from 'styled-components';

export const Container = styled('div')(({theme}) => ({
  width: '100%',
  padding: '0.5rem 1rem',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
  backgroundColor: theme.bgColors.primaryDefault,
  color: 'white',
  fontSize: '1rem',
  boxShadow: '0px 3px 6px ' + theme.auxColors.boxShadow,
  'a': {
    color: 'inherit',
    transition: 'all 0.3s ease-in-out',
    padding: '0.5rem 0.75rem',
    borderBottom: '3px solid rgba(255,255,255,0)',
    ':hover': {
      color: theme.textColors.primaryDarken01,
      transform: 'scale(1.025)',
      borderBottom: '3px solid rgba(255,255,255,0.25)',
    },
  },
  'a.active': {
    borderBottom: '3px solid rgba(255,255,255,0.5)',
    ':hover': {
      borderBottom: '3px solid rgba(255,255,255,1)',
    }
  },
}));

export const HmgLabel = styled('div')(({theme}) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  backgroundColor: theme.bgColors.danger || '#dc3545',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60px',
  width: 'calc(2rem * 5)',
  transform: 'translate(-35%, -14%) rotate(-45deg)',
  boxShadow: '2px 0 5px 2px rgba(0, 0, 0, 0.3)',
  fontSize: '1.1rem',
  fontWeight: 'bold',
  letterSpacing: '2px',
  zIndex: '1000',
  cursor: 'default',
}));

export const HmgLabelTopRight = styled('div')(({theme}) => ({
  position: 'fixed',
  top: 0,
  right: 0,
  backgroundColor: theme.bgColors.danger || '#dc3545',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60px',
  width: 'calc(2rem * 5)',
  transform: 'translate(35%, -14%) rotate(45deg)',
  boxShadow: '2px 0 5px 2px rgba(0, 0, 0, 0.3)',
  fontSize: '1.1rem',
  fontWeight: 'bold',
  letterSpacing: '2px',
  zIndex: '1000',
  cursor: 'default',
}));

export const Logo = styled('div')(({theme}) => ({
  height: '60px',
  padding: '0 1rem',
  display: 'flex',
  gap: '1.5rem',
  alignItems: 'center',
  fontSize: '1.3725rem',
  fontWeight: '900',
  'a': {
    display: 'block',
    padding: '0',
    border: '0',
    color: 'white',
    borderBottom: '3px solid rgba(255,255,255,0) !important',
    ':hover': {
      border: '0'
    }
  },
  'img': {
    height: '60px',
    width: 'auto',
    display: 'block',
    objectFit: 'contain',
    border: '0',
    ':hover': {
      border: '0'
    }
  },
  '> span': {
    color: '#4b80d5'
  }
}));

export const Actions = styled('div')(({theme}) => ({
  display: 'flex',
  gap: '1.5rem',
  alignItems: 'center',
  fontSize: '1rem',
  fontWeight: 'bold',
}));